import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { CookiesLawService } from "app/core/services/cookies-law.service";

@Component({
  templateUrl: "./cookies-law-dialog.component.html",
  styleUrls: ["./cookies-law-dialog.component.scss"],
  standalone: false
})
export class CookiesLawDialogComponent implements OnInit {
  public analyticsEnabled: boolean;
  public targetingEnabled: boolean;
  public googleTagManagerEnabled: boolean;
  public isEtrackerEnabled: boolean;
  public isAppsFlyerEnabled: boolean;

  constructor(
    private dialogRef: MatDialogRef<CookiesLawDialogComponent>,
    public cookiesLawService: CookiesLawService
  ) {}

  ngOnInit() {
    this.analyticsEnabled = this.cookiesLawService.isAnalyticsEnabled;
    this.targetingEnabled = this.cookiesLawService.isTargetingEnabled;
    this.googleTagManagerEnabled = this.cookiesLawService.isGoogleTagManagerEnabled;
    this.isEtrackerEnabled = this.cookiesLawService.isEtrackerEnabled;
    this.isAppsFlyerEnabled = this.cookiesLawService.isAppsFlyerEnabled;
  }

  public onClickAllow(): void {
    this.cookiesLawService.allowAll();
    this.closeDialog();
  }

  public onClickDisable(): void {
    this.cookiesLawService.disallowAll();
    this.closeDialog();
  }

  public onClickSave(): void {
    if (this.analyticsEnabled) {
      this.cookiesLawService.enableAnalytics();
    } else {
      this.cookiesLawService.disableAnalytics();
    }

    if (this.googleTagManagerEnabled) {
      this.cookiesLawService.enableGoogleTagManager();
    } else {
      this.cookiesLawService.disableGoogleTagManager();
    }

    if (this.targetingEnabled) {
      this.cookiesLawService.enableTargeting();
    } else {
      this.cookiesLawService.disableTargeting();
    }

    if (this.isAppsFlyerEnabled) {
      this.cookiesLawService.enableAppsFlyer();
    } else {
      this.cookiesLawService.disableAppsFlyer();
    }

    if (this.isEtrackerEnabled) {
      this.cookiesLawService.enableEtracker();
    } else {
      this.cookiesLawService.disableEtracker();
    }

    this.closeDialog();
  }

  private closeDialog(): void {
    this.dialogRef.close();
  }
}
